import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {MatButton, MatMiniFabButton} from "@angular/material/button";


@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.css"],
    imports: [MatMiniFabButton, MatIcon, MatButton]
})
export class ButtonComponent {

  @Input() type?: "circle" | "rounded" = "rounded";
  @Input() size?: "s" | "m" | "l" | "xl" = "l";
  @Input() svgIcon?: string;
  @Input() ariaLabel?: any;
  @Input() color? = "primary";
  @Input() class?;
  @Input() disabled? = false;
  @Input() text?;
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();

  fontSizeMap = {
    "s": "height: 1rem !important",
    "m": "height: 1.5rem !important",
    "l": "height: 2.5rem !important",
    "xl": "height: 3rem !important",
  };

  onClick() {
    this.clicked.emit();
  }
}
